import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class UserStatService {

  USER_STATS_URL : string = environment.serverUrl + "api/1/contracts/stats";

  constructor(private http: HttpClient) {
  }

  getUserStats() {
    return this.http.get(this.USER_STATS_URL);
  }


}



// WEBPACK FOOTER //
// ./src/app/statistics/user-stat.service.ts